export enum VisibilityEnum {
  "Public" = 1,
  "Private" = 2,
  "Contacts_Only" = 3,
}